<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <ul>
                        <li @click="scrollToElement('vn-1')">[出席情報]画面への入り方</li>
                        <li @click="scrollToElement('vn-2')">コース検索</li>
                        <li @click="scrollToElement('vn-3')">出席受講者一覧のエクスポート</li>
                        <li @click="scrollToElement('vn-4')">出席受講者一覧</li>
                        <li @click="scrollToElement('vn-5')">欠席者一覧</li>
                    </ul>
                </div>
                <div id="vn-1">
                    <h1>1.[出席情報]画面への入り方 </h1>
                </div>
                <div><img src="/static\images\ja\newManual\manageAttendanceManual-1.png" alt="" /></div>
                <div>
                    <p>①[ログインユーザアイコン]をクリックし、管理者用の管理メニューを開きます。</p>
                    <p>②[出席情報]をクリックすると、管理対象の全てのオンラインコースが表示されている[出席情報]画面に遷移します。</p>
                </div>
                <div id="vn-2">
                    <h1>2.コース検索 </h1>
                </div>
                <div><img src="/static\images\ja\newManual\manageAttendanceManual-2.png" alt="" /></div>
                <div>
                    <p>①検索するコース名を入力し、検索アイコンをクリックしてコース検索を行います。</p>
                    <p>②検索するコースの開始日を選択し、検索アイコンをクリックしてコース検索を行います。</p>
                </div>
                <div id="vn-3">
                    <h1>3.出席受講者一覧のエクスポート</h1>
                </div>
                <div><img src="/static\images\ja\newManual\manageAttendanceManual-3.png" alt="" /></div>
                <div>
                    <p>[受講者一覧出力]ボタンをクリックして、コースのすべての出席情報をExcelファイルにエクスポートします</p>
                </div>
                <div id="vn-4">
                    <h1>4.出席受講者一覧 </h1>
                </div>
                <div><img src="/static\images\ja\newManual\manageAttendanceManual-4.png" alt="" /></div>
                <div>
                    <p>検索したい受講者の名前を入力してください。</p>
                </div>
                <div id="vn-5">
                    <h1>5.欠席者一覧 </h1>
                </div>
                <div>
                    <p>
                        <b><i>5.1.受講者の検索 </i></b>
                    </p>
                </div>
                <div><img src="/static\images\ja\newManual\manageAttendanceManual-5.png" alt="" /></div>
                <div>
                    <p>検索したい受講者の名前を入力してください。</p>
                </div>
                <div>
                    <p>
                        <b><i>5.2.受講者の出席 </i></b>
                    </p>
                </div>
                <div><img src="/static\images\ja\newManual\manageAttendanceManual-6.png" alt="" /></div>
                <div>
                    <p>[＋]ボタンをクリックして参加してください。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                typeLanguage: 3,
            };
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {
            this.typeLanguage = this.$lang();
        },
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/manageAttendance_manual.vue